export const DEV = process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
export const STAGING = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
export const PRO = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

export const HOSTNAME = process.env.NEXT_PUBLIC_PROJECT_HOSTNAME

export const LANG = process.env.NEXT_PUBLIC_LOCALE
export const DY_COOKIE_SESSION = 'DY_USER_VIRBAC_UK'
export const DY_COOKIE_DOMAIN = HOSTNAME


export * from './base'
export * from './project'


